export default [
  {
    path: "/web/order-dashboard/:location?",
    name: "Web: Order Dashboard",
    component: () =>
      import(/* webpackChunkName: "web" */ "@/pages/Web/OrderDashboard")
  },
  {
    path: "/web/users",
    name: "Web: User List",
    component: () =>
      import(/* webpackChunkName: "users" */ "@/pages/Web/Users/List")
  },
  {
    path: "/web/users/:uid",
    name: "Web: User Edit",
    component: () =>
      import(/* webpackChunkName: "users" */ "@/pages/Web/Users/Edit")
  },
  {
    path: "/web/locations",
    name: "Web: Location List",
    component: () =>
      import(/* webpackChunkName: "locations" */ "@/pages/Web/Locations/List")
  },
  {
    path: "/web/locations/add",
    name: "Web: Location Add",
    component: () =>
      import(/* webpackChunkName: "locations" */ "@/pages/Web/Locations/Add")
  },
  {
    path: "/web/locations/:id",
    name: "Web: Location Edit",
    component: () =>
      import(/* webpackChunkName: "locations" */ "@/pages/Web/Locations/Edit")
  },
  {
    path: "/web/locations/:id/menu",
    name: "Web: Location Menu Edit",
    component: () =>
      import(
        /* webpackChunkName: "locations" */ "@/pages/Web/Locations/Menu/Edit"
      )
  },
  {
    path: "/web/reports",
    name: "Web: Reports",
    component: () =>
      import(/* webpackChunkName: "reports" */ "@/pages/Web/Reports/Dashboard")
  },
  {
    path: "/web/reports/transactions",
    name: "Web: Transaction List",
    props: route => ({ startDate: route.query.start_date }),
    component: () =>
      import(
        /* webpackChunkName: "reports" */ "@/pages/Web/Reports/Transactions/List"
      )
  },
  {
    path: "/web/reports/transactions/:id",
    name: "Web: Transaction Detail",
    component: () =>
      import(
        /* webpackChunkName: "reports" */ "@/pages/Web/Reports/Transactions/Detail"
      )
  },
  {
    path: "/web/reports/reconciliation",
    name: "Web: Reconciliation Report",
    props: route => ({ startDate: route.query.start_date }),
    component: () =>
      import(
        /* webpackChunkName: "reports" */ "@/pages/Web/Reports/Reconciliation"
      )
  }
];
